<!-- Page Header -->
<div class="page-header">
  <div class="page-header-left">
    <div class="page-header-icon">
      <i class="pi pi-wallet"></i>
    </div>
    <div class="page-header-text">
      <h1>{{ texts.titulo }}</h1>
      <p>{{ texts.subtitulo }}</p>
    </div>
  </div>
</div>

<!-- Filtros -->
<div class="filtros-section">
  <!-- Navegacao por mes -->
  <div class="mes-navegacao" *ngIf="!usandoPeriodoCustomizado">
    <button pButton
      icon="pi pi-chevron-left"
      class="p-button-text p-button-rounded p-button-sm btn-mes"
      (click)="mesAnterior()">
    </button>
    <span class="mes-label">{{ mesAnoLabel }}</span>
    <button pButton
      icon="pi pi-chevron-right"
      class="p-button-text p-button-rounded p-button-sm btn-mes"
      (click)="proximoMes()">
    </button>
  </div>

  <div class="periodo-customizado-label" *ngIf="usandoPeriodoCustomizado">
    <span>{{ periodoSelecionado.texto }}</span>
    <button pButton
      icon="pi pi-times"
      class="p-button-text p-button-rounded p-button-sm"
      (click)="usandoPeriodoCustomizado = false; recalcularPeriodo(); carregarDados();">
    </button>
  </div>

  <!-- Botao periodo customizado -->
  <app-periodo-filtro
    modo="avancado"
    [valorPadrao]="'showAll'"
    [persistir]="true"
    [textoExibicao]="periodoSelecionado.texto"
    styleClass="btn-periodo-icon"
    (periodoChanged)="onPeriodoChange($event)">
  </app-periodo-filtro>

  <!-- Conta -->
  <p-dropdown
    [options]="contas"
    [(ngModel)]="contaSelecionada"
    [showClear]="true"
    [placeholder]="labels.todas_as_contas"
    [loading]="loadingContas"
    optionLabel="label"
    optionValue="value"
    (onChange)="onFiltroChange()"
    styleClass="filtro-conta">
    <ng-template pTemplate="selectedItem">
      <div class="dropdown-conta-item" *ngIf="contaSelecionada !== null && contaSelecionada !== undefined">
        <img *ngIf="getContaFlagUrl(contaSelecionada)" [src]="getContaFlagUrl(contaSelecionada)" class="flag-icon-small" alt="" />
        <span>{{ getContaLabel(contaSelecionada) }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-conta>
      <div class="dropdown-conta-item">
        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
        <span>{{ conta.label }}</span>
      </div>
    </ng-template>
  </p-dropdown>

  <!-- Tipo de Despesa -->
  <p-dropdown
    [options]="tipoDespesaOptions"
    [(ngModel)]="tipoDespesaSelecionada"
    [showClear]="true"
    [placeholder]="labels.todos_os_tipos"
    [loading]="loadingTipos"
    optionLabel="label"
    optionValue="value"
    (onChange)="onFiltroChange()"
    styleClass="filtro-tipo">
  </p-dropdown>

  <!-- Busca por descricao -->
  <span class="p-input-icon-left filtro-busca">
    <i class="pi pi-search"></i>
    <input
      type="text"
      pInputText
      [placeholder]="placeholders.buscar_descricao"
      [value]="searchDescricao"
      (input)="onSearchInput($event)"
      [attr.aria-label]="placeholders.buscar_descricao" />
  </span>
</div>

<!-- Cards de Totais por Moeda -->
<div class="totais-moeda-section" *ngIf="!loadingTotais && cardsTotais.length > 0">
  <div class="totais-moeda-cards">
    <div class="total-moeda-card total-guarani"
      *ngIf="cardsTotais[0]"
      [class.total-moeda-card--active]="filtroMoedaSelecionada === 'GUARANI'"
      (click)="filtrarPorMoeda('GUARANI')">
      <div class="total-moeda-icon">
        <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="" />
      </div>
      <div class="total-moeda-info">
        <span class="total-moeda-label">{{ cardsTotais[0].label }}</span>
        <span class="total-moeda-valor">Gs {{ cardsTotais[0].valor | number:'1.0-0':'es-PY' }}</span>
      </div>
      <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'GUARANI'"></i>
    </div>
    <div class="total-moeda-card total-dolar"
      *ngIf="cardsTotais[2]"
      [class.total-moeda-card--active]="filtroMoedaSelecionada === 'DOLAR'"
      (click)="filtrarPorMoeda('DOLAR')">
      <div class="total-moeda-icon">
        <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="" />
      </div>
      <div class="total-moeda-info">
        <span class="total-moeda-label">{{ cardsTotais[2].label }}</span>
        <span class="total-moeda-valor">$ {{ cardsTotais[2].valor | number:'1.2-2':'en-US' }}</span>
      </div>
      <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'DOLAR'"></i>
    </div>
    <div class="total-moeda-card total-real"
      *ngIf="cardsTotais[1]"
      [class.total-moeda-card--active]="filtroMoedaSelecionada === 'REAL'"
      (click)="filtrarPorMoeda('REAL')">
      <div class="total-moeda-icon">
        <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="" />
      </div>
      <div class="total-moeda-info">
        <span class="total-moeda-label">{{ cardsTotais[1].label }}</span>
        <span class="total-moeda-valor">R$ {{ cardsTotais[1].valor | number:'1.2-2':'pt-BR' }}</span>
      </div>
      <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'REAL'"></i>
    </div>
  </div>
</div>

<!-- Skeleton dos cards resumo -->
<div class="totais-moeda-section" *ngIf="loadingTotais">
  <div class="totais-moeda-cards">
    <p-skeleton *ngFor="let i of [1, 2, 3]" width="100%" height="60px" borderRadius="12px" styleClass="flex-1"></p-skeleton>
  </div>
</div>

<!-- Table Card - Lista de Despesas -->
<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-list"></i>
    </div>
    <span class="card-header-title">{{ labels.lista_despesas }}</span>
  </div>

  <div class="card-content">
    <!-- Tabela -->
    <p-table [value]="dados" [loading]="loading"
      [tableStyle]="{ 'width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 8%">{{ labels.id }}</th>
          <th style="width: 15%">{{ labels.data_emissao }}</th>
          <th style="width: 25%">{{ labels.descricao }}</th>
          <th style="width: 18%">{{ labels.tipo_despesa }}</th>
          <th style="width: 17%">{{ labels.pessoa }}</th>
          <th class="num-col" style="width: 17%">{{ labels.valor }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.id }}</td>
          <td>{{ formatarEmissao(item.emissao) }}</td>
          <td>{{ item.observacao || '-' }}</td>
          <td>
            <div class="flex align-items-center gap-2">
              <div *ngIf="getTipoDespesaIcone(item.tipoDespesa) || getTipoDespesaCor(item.tipoDespesa)"
                class="flex align-items-center justify-content-center border-circle"
                [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: getTipoDespesaCor(item.tipoDespesa) || '#eceff4' }">
                <i class="{{ getTipoDespesaIcone(item.tipoDespesa) || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
              </div>
              <span>{{ getTipoDespesaLabel(item.tipoDespesa) }}</span>
            </div>
          </td>
          <td>{{ item.pessoa?.nome || '-' }}</td>
          <td class="num-col negative">{{ getMoedaSimbolo(item.moedaDeOrigem) }} {{ item.valor | number:'1.0-0' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ labels.nenhum_resultado }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="6" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container" *ngIf="totalRecords > 0">
      <p-paginator
        [rows]="rows"
        [totalRecords]="totalRecords"
        [first]="first"
        [rowsPerPageOptions]="[10, 20, 50]"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  </div>
</div>
